import { type AxiosInstance } from 'axios'

type Pollutants = {
  name: string
  chemical_formula: string
  ar: string
  gwp: number

}
export default (axios: AxiosInstance) => ({
  getAr5Pollutants() {
    return axios.get(`/v1/pollutants/get-ar5-pollutants/`)
  },
  getSelectedPollutants(cid: number | string) {
    return axios.get(`/v1/pollutants/${cid}/selected-pollutants/`)
  },
  updateSelectedPollutants(cid: number | string, selectedPollutantId: number | string, data: object) {
    return axios.patch(`/v1/pollutants/company/${cid}/${selectedPollutantId}/selected-pollutants/update/`, data)
  },
  getPollutants() {
    return axios.get('/v1/pollutants/')
  },
  deletePollutants(shortcode: string) {
    return axios.delete(`/v1/pollutants/${shortcode}/`)
  },
  createPollutants(data: Pollutants) {
    return axios.post(`/v1/pollutants/`, data)
  },
  getPollutantsById(shortcode: string) {
    return axios.get(`/v1/pollutants/${shortcode}/`)
  },
  updatePollutants(shortcode: string | number, data: Pollutants) {
    return axios.put(`/v1/pollutants/${shortcode}/`, data)
  },
})
